<div class="app-loader" [ngClass]="{'app-loader--loading': (loading$ | async)}">
	<span class="app-loader__container">
		<!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
		<cm-loading-icon></cm-loading-icon>
	</span>
</div>
